import { Component, OnInit } from '@angular/core';
import { MasterdataService } from 'src/app/services/APIs/MasterData/masterdata.service';
import { DataContextService } from 'src/app/services/datacontext.service';
import { Configuration } from '../../../../models/masterdata.model';
import { SelectedOwnerItem } from '../../../../shared/components/owner-search/owner-search.component';

@Component({
  selector: 'app-staticlink-navigation',
  templateUrl: './staticlink-navigation.component.html',
  styleUrls: ['./staticlink-navigation.component.less']
})
export class StaticlinkNavigationComponent implements OnInit {
  public staticURL:staticURL;
  public MagnetNavigationUrl:string
  RECOMMENDATION_LIST_PAGE_SIZE:number=40

  constructor(private datacontextService:DataContextService,private masterdataservice:MasterdataService) { }

  ngOnInit(): void {
    this.datacontextService.masterDadaLoaded$.subscribe(res=>{
      if(res){
        this.staticURL={
          magnetTimelineUrl: this.getLinkValue(DataContextService.Configurations, 'MagnetTimelineUrl'),
          serviceNowUrl: this.getLinkValue(DataContextService.MemberFirmConfigurations, 'ServiceNowURL'),
          hotelingUrl: this.getLinkValue(DataContextService.MemberFirmConfigurations, 'HotelingURL'),
          cateringForBuilding: this.getLinkValue(DataContextService.Configurations,'CateringForBuildingURL'),
          magnetProfileUrl: this.getLinkValue(DataContextService.Configurations, 'MagnetURL'),
          serviceOrderReports: this.getLinkValue(DataContextService.MemberFirmConfigurations, 'ServiceOrderReports'),
          reportsUrl: this.getLinkValue(DataContextService.MemberFirmConfigurations, 'ReportsURL')
          }
      }
    })
  }
  getLinkValue(data, propertyName): string | null {
    const property = data.find(item => item.name == propertyName) as Configuration;
    if (property)
          return property.value;
      else
          return null;
  }

  delegateselect(user: SelectedOwnerItem[]) {
    this.MagnetNavigationUrl = `${this.staticURL.magnetTimelineUrl}`;
    this.MagnetNavigationUrl = this.MagnetNavigationUrl.replace('{0}', DataContextService.UserData.userName);
    this.MagnetNavigationUrl = this.MagnetNavigationUrl.replace('{1}', user[0].userName);
    window.open(this.MagnetNavigationUrl, '_blank');
  }

}
export interface staticURL{
    serviceNowUrl: string
    hotelingUrl:string
    cateringForBuilding: string
    magnetProfileUrl:string
    serviceOrderReports: string
    reportsUrl:string
    magnetTimelineUrl:string
}
